/**
 * Spotlight coaches + Parcours companion dock.
 * Off until tours are stable enough to ship again.
 * Flip to `true` to re-enable TourOverlay, Parcours strip, and settings entry.
 */
export const TOURS_ENABLED = false;
